module.exports = __webpack_public_path__ + "static/media/BM_Brand.d05ff31b.svg";